import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { LanguageContext } from "../context/LanguageContext";
import { Row, Col, Container } from "react-bootstrap";

const Contact = () => {
  const { translations } = useContext(LanguageContext);

  // Form State
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    message: "",
  });

  // Error State
  const [errors, setErrors] = useState({});

  // Reset errors when language changes
  useEffect(() => {
    setErrors({}); // Clear validation errors when language changes
  }, [translations]);

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error when user types
  };

  // Validate Form
  const validateForm = () => {
    let newErrors = {};

    if (!formData.username) newErrors.username = translations.contact?.userError;
    if (!formData.email) {
      newErrors.email = translations.contact?.emailError;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = translations.contact?.invalidEmail;
    }
    if (!formData.message) newErrors.message = translations.contact?.messageError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if validation fails

    try {
      const response = await axios.post(
        "https://dev-admin-api.rimligtaxi.se/api/v1/contact-us",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("API Response:", response.data);

      // Show success message
      alert(translations.contact?.successMessage);

      // Clear the form
      setFormData({ username: "", email: "", message: "" });
      setErrors({});
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(translations.contact?.errorMessage);
    }
  };

  return (
    <div className="padding_cmn contact_us" id="contact">
      <Container>
        <Row className="align-items-center">
          <Col lg={7}>
            <div className="contact_text">
              <h6 className="rm_subheading">{translations.contact?.subTitle}</h6>
              <h2 className="subTitle">{translations.contact?.title}</h2>
              <p className="rm_why_text text-start">{translations.contact?.description}</p>
            </div>
          </Col>
          <Col lg={5}>
            <div className="contact_form">
              <form onSubmit={handleSubmit}>
                {/* Username Field */}
                <div className="form-group mb-3">
                  <label htmlFor="username">{translations.contact?.userName}</label>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder={translations.contact?.userPlaceholder}
                    className="form-control"
                  />
                  {errors.username && <p className="text-danger">{errors.username}</p>}
                </div>

                {/* Email Field */}
                <div className="form-group mb-3">
                  <label htmlFor="email">{translations.contact?.email}</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={translations.contact?.emailPlaceholder}
                    className="form-control"
                  />
                  {errors.email && <p className="text-danger">{errors.email}</p>}
                </div>

                {/* Message Field */}
                <div className="form-group mb-4">
                  <label htmlFor="message">{translations.contact?.message}</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                    rows={5}
                    placeholder={translations.contact?.messagePlaceholder}
                  />
                  {errors.message && <p className="text-danger">{errors.message}</p>}
                </div>

                {/* Submit Button */}
                <button type="submit" className="rm_cmn_btn w-100">
                  {translations.contact?.buttonText}
                </button>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
